
import {degreeLevels} from '../degreeLevel'

export function userTitle({degreeLevel,gender,firstName='',lastName=''}={}, def=''){
    var d= degreeLevel>=degreeLevels.doctoral?'دکتر ':
        degreeLevel===degreeLevels.bachelorOfEngineering || degreeLevel===degreeLevels.masterOfEngineering? 'مهندس '
        :'';
    var g =  !gender?'آقای':'خانم';
    return lastName? g + ' '+ d + firstName+ ' '+ lastName:(def||firstName);
}